module.exports = __webpack_public_path__ + "static/media/DecPassportFront.catalyst.1e6797e4.tsx";